import { useFormikContext } from 'formik';
import { Loader2 } from 'lucide-react';
import type { ComponentProps } from 'react';

import { Button } from '@/components/ui/button';

type Props = ComponentProps<typeof Button> & {
  isPending: boolean;
  label?: string;
  loadingLabel?: string;
};

export const SubmitButton = ({ isPending, label, loadingLabel, ...props }: Props) => {
  const { isValid, dirty } = useFormikContext();

  return (
    <Button type="submit" className="flex-1" disabled={!isValid || !dirty || isPending} {...props}>
      {isPending ? (
        <>
          <Loader2 className="h-4 w-4 animate-spin" />
          {loadingLabel || 'Saving changes...'}
        </>
      ) : (
        label || 'Save changes'
      )}
    </Button>
  );
};
